// FormikMultiSelect.js

import React, { useContext, useCallback, useRef } from "react";
import { ErrorMessage, Field, useFormikContext } from "formik";
import MultiSelect from "multiselect-react-dropdown";
import TextError from "../TextError";
import { Typography } from "@mui/material";
import FormikControlContext from "../../../Contexts/FormikControlContext";

const FormikMultiSelect = () => {
  const field = useContext(FormikControlContext);
  const { label, name, options } = field;

  const multiselectRef = useRef(null);

  const onSelect = useCallback((selectedList, selectedItem) => {
    // Do something with selected values
  }, []);

  const onRemove = useCallback((selectedList, removedItem) => {
    // Do something when an item is removed
  }, []);

  return (
    <div>
      <Typography>{label}</Typography>

      <Field name={name}>
        {({ field }) => {
          return (
            <MultiSelect
              name={name}
              disablePreSelectedValues
              selectedValues={field.value}
              onRemove={onRemove}
              onSelect={onSelect}
              groupBy="cat"
              options={options}
              displayValue="label"
              showCheckbox
              placeholder={label}
              ref={multiselectRef}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FormikMultiSelect;
